"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOMENT_PHOTO_MAX_BYTES = exports.MAX_STICKERS_PAGE_SIZE = exports.MAX_CONTENT_REPORT_REASON_LENGTH = exports.STICKERS_CHECK_IN_WINDOW_DAYS = exports.NOTE_LIKE_EMOJI = exports.MOMENT_POST_COOLDOWN_HOURS = exports.MOMENT_TEMPORARY_LIFETIME_HOURS = exports.NOTE_TEMPORARY_LIFETIME_DAYS = void 0;
/** A "Temporary" Note disappears this many days after it's posted ("Keep it on my profile" never expires). */
exports.NOTE_TEMPORARY_LIFETIME_DAYS = 30;
/** A "Temporary" Moment (photo sticker) disappears this many hours after it's posted. */
exports.MOMENT_TEMPORARY_LIFETIME_HOURS = 24;
/** A user can post one Moment per venue in this window, whether it's temporary or kept on the profile. */
exports.MOMENT_POST_COOLDOWN_HOURS = 24;
/** Liking a Note is stored as this reaction emoji, so likes and the existing emoji reactions share one table. */
exports.NOTE_LIKE_EMOJI = '❤️';
/** "Check-ins the last N days" on the venue's Stickers card. */
exports.STICKERS_CHECK_IN_WINDOW_DAYS = 30;
exports.MAX_CONTENT_REPORT_REASON_LENGTH = 500;
/** Page size cap for the paginated Notes / Moments lists ("See All"). */
exports.MAX_STICKERS_PAGE_SIZE = 50;
/** Largest Moment photo the server accepts. Prod nginx allows a bit more (12m), so oversized photos get our JSON 413. */
exports.MOMENT_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=stickers.js.map